/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxGamesLibWebPlatformDataOptionsSteamOptions } from './FxGamesLibWebPlatformDataOptionsSteamOptions';
import {
    instanceOfFxGamesLibWebPlatformDataOptionsSteamOptions,
    FxGamesLibWebPlatformDataOptionsSteamOptionsFromJSON,
    FxGamesLibWebPlatformDataOptionsSteamOptionsFromJSONTyped,
    FxGamesLibWebPlatformDataOptionsSteamOptionsToJSON,
} from './FxGamesLibWebPlatformDataOptionsSteamOptions';

/**
 * @type FxGamesLibWebPlatformDataOptionsSteam
 * 
 * @export
 */
export type FxGamesLibWebPlatformDataOptionsSteam = FxGamesLibWebPlatformDataOptionsSteamOptions;

export function FxGamesLibWebPlatformDataOptionsSteamFromJSON(json: any): FxGamesLibWebPlatformDataOptionsSteam {
    return FxGamesLibWebPlatformDataOptionsSteamFromJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsSteamFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPlatformDataOptionsSteam {
    if (json == null) {
        return json;
    }
    if (instanceOfFxGamesLibWebPlatformDataOptionsSteamOptions(json)) {
        return FxGamesLibWebPlatformDataOptionsSteamOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxGamesLibWebPlatformDataOptionsSteamToJSON(json: any): any {
    return FxGamesLibWebPlatformDataOptionsSteamToJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsSteamToJSONTyped(value?: FxGamesLibWebPlatformDataOptionsSteam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxGamesLibWebPlatformDataOptionsSteamOptions(value)) {
        return FxGamesLibWebPlatformDataOptionsSteamOptionsToJSON(value as FxGamesLibWebPlatformDataOptionsSteamOptions);
    }

    return {};
}

